import { Component } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import Button from '../../Nodes/Button'
import Select from './Select'
import Text from './Text'
import Toggle from '../../Nodes/Toggle'
import { H1, Body1 } from '../../Nodes/Typography'
import { post } from '../../../utilities/requests'
import { logEvent, logError, sanitizeJsonForLogs } from '../../../../../utilities'

class Contact extends Component {
    state = {
        sending: false,
        fields: { 
            clientCopy: false
        }
    }

    resetState = (message) => {
        const fields = 
            this.props.fields.reduce(
                (acc, f) => ({ ...acc, [f.name]: f.value || '' }), {})

        this.setState({ 
            sending: false,
            message,
            fields: { ...this.state.fields,  ...fields }
        })
    }

    handleInput = property => e => this.setState({ 
        fields: {
            ...this.state.fields,
            [property]: e.target.value,
        },
        errorMessage: undefined 
    })
    
    handleSubmit = (e) => {
        e && e.preventDefault()
        this.setState({ sending: true })

        const { fields, topic, onSubmit, onError } = this.props

        // Browser auth should take care of this check. But just to make sure.
        let valid = true
        for (const field in fields) {
            if (valid && field.required) 
                this.valid = !!this.state[field.name]
        }

        if (valid) {
            const body = { ...this.state.fields, Topic: topic }
            post('/Email/Send', body, 'application/json')
                .then(response => {
                    if (response.status !== 200) {
                        this.setState({ errorMessage: 'We are currently having problems with our email server. Please try again later.'})
                        logError(`Error Reaching Endpoint [/Email/Send]`, response)
                        onError && onError(response)
                    }
                    else {
                        this.resetState('Message Sent. Someone from our team will be in touch with you as quickly as possible.')
                        logEvent({'Contact Email Sent': sanitizeJsonForLogs(body) })
                        onSubmit && onSubmit()
                    }
                })
        }
    }

    verifyReCaptcha = (token) => {
        this.setState({ fields: { ...this.state.fields, 'g-recaptcha-response': token }})
    }

    renderField = (field, key) => {
        switch (field.type) {
            case 'text':
            case 'email':
            case 'tel':
            case 'textarea':
            case 'phone':
                return <Text {...field} value={this.state.fields[field.name] ?? ''} key={key} onInput={this.handleInput(field.name)}/>
            case 'select':
                return <Select {...field} value={this.state.fields[field.name] ?? ''} key={key} onInput={this.handleInput(field.name)} />
            default:
                return null
        }
    }

    render() {
        const { instructions } = this.props

        return (
            <form className="contact-form" onSubmit={this.handleSubmit}>                
                { this.state.message && <div>{this.state.message}</div> }
                { this.state.errorMessage && <div>{this.state.errorMessage}</div> }
                { this.props.title && <H1>{this.props.title}</H1>}
                { this.props.image && <img className="contact-form__image" alt="contact"src={this.props.image} />}
                <div className="contact-form__body">
                    <div className="grid">
                        { this.props.fields && this.props.fields.map(this.renderField) }
                    </div>
                    { instructions && instructions.length > 0 && (
                        <div className="contact-form__body__instructions">
                            { instructions.map((x, i) => (
                                <Body1 key={'contact-form__instruction--' + i}>
                                    <div className="contact-form__body__instructions__identifier">{i + 1}.</div>
                                    <div>{x}</div>
                                </Body1>    
                            )) }
                        </div>
                    )}
                </div>
                <Toggle
                    type="checkbox"
                    checked={this.state.fields.clientCopy}
                    onChange={(e) => this.setState({ fields: { ...this.state.fields, clientCopy: e.target.checked }})}>
                    Send yourself a copy
                </Toggle><br />
                <ReCAPTCHA
                    sitekey="6LcZFVcUAAAAAAYMVnZbYMPrJzpYIZ7G30nqH-rI"
                    onChange={this.verifyReCaptcha} />
                <div className="contact-form__button-container">
                    { this.state.sending ?
                        <Button raised disabled>Sending...</Button> :
                        <Button raised disabled={!this.state.fields['g-recaptcha-response']}>{this.props.actionMessage ? this.props.actionMessage : 'Submit'}</Button> }
                </div>
            </form>
        )
    }

    componentDidMount() {
        this.resetState()
    }
}

Contact.propTypes = {
    title: PropTypes.string,
    image: PropTypes.string,
    instructions: PropTypes.array,
    actionMessage: PropTypes.string,
    topic: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            value: PropTypes.any,
            required: PropTypes.bool,
            options: PropTypes.array,
            span: PropTypes.string,
            title: PropTypes.string,
            placeholder: PropTypes.string
        })
    ).isRequired,
    onSubmit: PropTypes.func,
    onError: PropTypes.func
}

export default Contact